import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const StatusAlert = ({ error, success, message ={sms: null, al: 2}, setMessage, setError, setSuccess, duration = 5000, alert = 0 }) => {
  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => setError(null), duration);
      return () => clearTimeout(timer);
    }
  }, [error, duration, setError]);

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(null), duration);
      return () => clearTimeout(timer);
    }
  }, [success, duration, setSuccess]);

    useEffect(() => {
    if (message.sms) {
      const timer = setTimeout(() => setMessage({sms: null, al: 2}), duration);
      return () => clearTimeout(timer);
    }
  }, [success, duration, setMessage]);

  let alertMessage 
 if(message.sms){
    if(message.al === 0){
alertMessage = "alert alert-danger"
  }else if(message.al === 1){
alertMessage = "alert alert-info"
  }else if(message.al === 2){
alertMessage = "alert alert-success"
  }else if(message.al === 3){
alertMessage = "alert alert-primary"
  }else if(message.al === 4){
alertMessage = "alert alert-secondary"
  }else if(message.al === 5){
alertMessage = "alert alert-dark"
  }else if(message.al === 6){
alertMessage = "alert alert-light"
  }else if(message.al === 7){
alertMessage = "alert alert-warning"
  }else{
alertMessage = "alert alert-danger"
  }

 }else{
  if(alert === 0){
alertMessage = "alert alert-danger"
  }else if(alert === 1){
alertMessage = "alert alert-info"
  }else if(alert === 2){
alertMessage = "alert alert-success"
  }else if(alert === 3){
alertMessage = "alert alert-primary"
  }else if(alert === 4){
alertMessage = "alert alert-secondary"
  }else if(alert === 5){
alertMessage = "alert alert-dark"
  }else if(alert === 6){
alertMessage = "alert alert-light"
  }else if(alert === 7){
alertMessage = "alert alert-warning"
  }else{
alertMessage = "alert alert-danger"
  }
 }

  return (
    <>
      {error && (
        <div className={alertMessage}>
          <div dangerouslySetInnerHTML={{ __html: error }} />
        </div>
      )}

      {success && (
        <div className="alert alert-success m-0 p-4">
          <div dangerouslySetInnerHTML={{ __html: success }} />
        </div>
      )}
       { message.sms && (
        <div className={alertMessage}>
          <div dangerouslySetInnerHTML={{ __html:  message.sms }} />
        </div>
      )}
    </>
  );
};

StatusAlert.propTypes = {
  error: PropTypes.string,
  success: PropTypes.string,
  setError: PropTypes.func,
  setSuccess: PropTypes.func,
  duration: PropTypes.number
};

export default StatusAlert;